
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'LogoLimaTec',
    props: {
        Altura: {
            type: String,
            default: "48px"
        }
    }
});
